import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import InsButton from "../../../../components/InsButton/InsButton";
import InsInput from "../../../../components/InsInput/InsInput";
import InsRadio from "../../../../components/InsRadio/InsRadio";
import "react-datepicker/dist/react-datepicker.css";
import Validate from "../../../../ressources/validation";
import StepCount from "../../../../components/StepCount/StepCount";
import "./Step2.scss";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import * as language from "date-fns/locale";
import { connect } from "react-redux";
import { getLocales } from "../../../../api/splashscreen";
import Select from "react-select";
class Step2 extends Component {
  constructor(props) {
    super(props);
    // radio inputs
    this.radio = [
      {
        value: props.t("M"),
        label: props.t("m"),
      },
      {
        value: props.t("F"),
        label: props.t("mme"),
      },
    ];

    const date = new Date();
    this.max_year = new Date(
      date.getFullYear() - 16,
      date.getMonth(),
      date.getDate()
    );
    this.min_year = new Date(
      date.getFullYear() - 100,
      date.getMonth(),
      date.getDate()
    );

    this.state = {
      languages: [],
      fields: [],
    };
  }

  static propTypes = {
    onValidate: PropTypes.func,
    userInfo: PropTypes.any,
  };

  componentDidMount() {
    const { config } = this.props;
    const { person } = config.register;
    this.setState({
      fields: person.map((field) => ({
        ...field,
        value: this.props.userInfo[field.name] || "",
        error: "",
      })),
    });
    this._getLocales();
  }

  _getLocales = () => {
    getLocales()
      .then((data) => {
        this.setState({ languages: data });
      })
      .catch((err) => console.log(err));
  };

  _handleChange = (input) => (e) => {
    const value = e.target.value;
    const { fields } = this.state;
    const index = fields.findIndex((el) => el.name === input);
    let newFields = [...fields];
    newFields[index].value = value;
    this.setState({ fields: newFields });
  };

  _handleBirthdate = (value) => {
    const { fields } = this.state;
    const index = fields.findIndex((el) => el.name === "birthdate");
    let newFields = [...fields];
    if (value > this.max_year) {
      value = this.max_year;
    } else if (value < this.min_year) {
      value = this.min_year;
    }

    // TODO FIX ERROR
    newFields[index].value = value;
    this.setState({ fields: newFields }, () => {
      this._validateField("birthdate")();
    });
  };

  _handleLanguage = (option) => {
    const { fields } = this.state;
    const index = fields.findIndex((el) => el.name === "primary_language");
    let newFields = [...fields];
    newFields[index].value = option.value;
    newFields[index].label = option.label;
    this.setState({ fields: newFields });
  };

  /**
   * Valide le formulaire de l'étape
   */
  _validateFormStep = () => {
    const { fields } = this.state;
    return fields.every((el) => this._validateField(el.name)(false));
  };

  _validateField =
    (input) =>
    (displayError = true) => {
      const { fields } = this.state;
      const index = fields.findIndex((el) => el.name === input);
      if (!fields[index].required) {
        return true;
      }
      const error =
        Validate("required", fields[index].value) ||
        Validate(fields[index].name, fields[index].value);
      if (displayError) {
        let newFields = [...fields];
        newFields[index].error = error;
        this.setState({
          fields: newFields,
        });
      }
      return !error;
    };

  _onValidate = () => {
    const { onValidate } = this.props;
    const { fields } = this.state;
    let store = {};
    fields.forEach((el) => {
      store[el.name] = el.value;
    });
    const userInfo = store;
    onValidate(userInfo);
  };

  // RENDER GENDER RADIO FIELD
  _renderGender = (field) => {
    return (
      <div className="radio-button-container">
        {this.radio.map((elem, i) => (
          <InsRadio
            key={elem.value}
            value={elem.value}
            name={"gender-" + i}
            label={elem.label}
            checked={field.value === elem.value}
            onChange={this._handleChange("gender")}
          />
        ))}
      </div>
    );
  };

  // RENDER INPUT FIELDS
  _renderFields = (field) => {
    const { t } = this.props;
    return (
      <div>
        <InsInput
          name={field.name}
          onChange={this._handleChange(field.name)}
          onBlur={() => {
            this._validateField(field.name)();
          }}
          placeholder={field.required ? t(field.name) + " *" : t(field.name)}
          value={field.value}
          error={field.error}
          autoComplete="new-password"
        />
      </div>
    );
  };

  // RENDER BIRTHDATE FIELD
  _renderBirthdate = (field) => {
    const { t, i18n } = this.props;
    let locale = i18n.language.replace(/-/g, "");
    let fullLocal = i18n.language;

    const languages = Object.keys(language);
    if (!languages.includes(locale)) {
      locale = locale.substring(0, 2);
      if (!languages.includes(locale)) {
        locale = "fr";
      }
    }

    registerLocale(`${locale}`, language[locale]);
    setDefaultLocale(`${locale}`);


    return (
      <div
        className={
          field.error ? "ins_input error datepicker" : "ins_input datepicker"
        }
      >
        <DatePicker
          selected={field.value ? new Date(field.value) : ""}
          onChange={this._handleBirthdate}
          placeholderText={
            field.required ? t(field.name) + " *" : t(field.name)
          }
          minDate={this.min_year}
          maxDate={this.max_year}
          dateFormat={language[locale].formatLong.date({width: 'short'})}
          className="ins_input ins_datePicker"
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          popperPlacement="top-center"
          onBlur={() => {
            this._validateField("birthdate")();
          }}
        />
        {field.error && (
          <div className={"error-" + field.name}>{t(field.error)}</div>
        )}
      </div>
    );
  };

  _renderLanguage = (field) => {
    const { t } = this.props;
    const { languages, fields } = this.state;
    const index = fields.findIndex((el) => el.name === field.name);
    let newFields = [...fields];
    newFields[index].label = newFields[index].label
      ? newFields[index].label
      : newFields[index].required
      ? t(field.name) + " *"
      : t(field.name);

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        color: "black",
      }),
      control: (provided, state) => ({
        ...provided,
        backgroundColor: "transparent",
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "white",
      }),
    };

    let table = [];
    languages.forEach((lang) => {
      table.push({
        value: lang.locale,
        label: lang.name,
      });
    });

    return (
      <div className={field.error ? "ins_input error" : "ins_input"}>
        <Select
          isSearchable={false}
          classNamePrefix={field.name}
          menuPlacement="bottom"
          styles={customStyles}
          className={field.name}
          value={{
            value: newFields[index].value,
            label: <div className="ls-row">{newFields[index].label}</div>,
          }}
          onChange={this._handleLanguage}
          options={table}
          onBlur={() => {
            this._validateField(field.name)();
          }}
        />
        {field.error && (
          <div className={"error-" + field.name}>{t(field.error)}</div>
        )}
      </div>
    );
  };

  render() {
    const { t, currentStep, maxSteps } = this.props;
    const { fields } = this.state;
    return (
      <form className="col-flex default-container step-2" onSubmit={(e) => e.preventDefault()}>
        <StepCount step={currentStep} maxStepCount={maxSteps} />
        <p className="bold-label centered mb50">{t("step2")}</p>

        {fields.map((field) => {
          switch (field.name) {
            case "gender":
              return <div key={field.name}>{this._renderGender(field)}</div>;

            case "birthdate":
              return <div key={field.name}>{this._renderBirthdate(field)}</div>;

            case "user_address":
            case "user_city":
            case "user_cp":
              return <div key={field.name}>{this._renderFields(field)}</div>;

            case "primary_language":
              return <div key={field.name}>{this._renderLanguage(field)}</div>;

            default:
              return <div key={field.name}>{this._renderFields(field)}</div>;
          }
        })}
        <div className="bottom-container">
          {!this._validateFormStep() && (
            <div className="alert_msg mb10">{t("required")}</div>
          )}
          <InsButton
            text={t("next")}
            onClick={this._onValidate}
            disabled={!this._validateFormStep()}
          />
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
  auth: state.auth,
});

export default connect(mapStateToProps)(withTranslation()(Step2));
